"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopMenuElements = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Menu_1 = require("./Menu");
const nav_icon_1 = require("./nav-icon");
const react_spring_1 = require("react-spring");
const search_input_1 = require("./search-input");
const DesktopMenuElements = (props) => {
    var _a;
    const context = React.useContext(Menu_1.MenuContext);
    const clickSearch = (e) => {
        e.preventDefault();
        context.setMenuState(Object.assign(Object.assign({}, context.menuState), { searchVisible: !context.menuState.searchVisible, modalVisible: false }));
    };
    const fadeIn = (0, react_spring_1.useSpring)({
        float: 'left',
        transitionTimingFunction: 'ease-in-out',
        opacity: context.menuState.modalVisible ? 0 : 1,
    });
    return (React.createElement(DesktopMenuWrap, null,
        context.menuState.searchVisible ? (React.createElement(search_input_1.SearchInput, { history: props.history })) : (React.createElement(React.Fragment, null,
            props.vistopp !== false && (React.createElement(AnimatedDiv, { style: fadeIn },
                React.createElement(MenuUl, { className: "large-menu" }, (_a = props === null || props === void 0 ? void 0 : props.menuelements) === null || _a === void 0 ? void 0 : _a.map((item) => {
                    return (React.createElement("li", { key: item.link },
                        React.createElement("a", { href: item.link }, item.name)));
                })))),
            React.createElement(MenuRightElements, { className: "menu-search-icon" },
                React.createElement("a", { onClick: clickSearch, href: "" },
                    React.createElement("svg", { width: "31", height: "31", viewBox: "0 0 31 31", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("path", { d: "M29.7224 27.2685L20.605 18.1494C22.0073 16.3081 22.7964 13.9408 22.7964 11.3976C22.7964 5.08477 17.7116 0 11.3988 0C5.08597 0 -0.000488281 5.08645 -0.000488281 11.3993C-0.000488281 17.7121 5.08428 22.7969 11.3971 22.7969C13.9403 22.7969 16.2188 22.0078 18.1489 20.6055L27.268 29.7246C27.6181 30.0747 28.0571 30.2506 28.496 30.2506C28.935 30.2506 29.3722 30.0747 29.7241 29.7246C30.4244 29.0226 30.4244 27.9704 29.7224 27.2685L29.7224 27.2685ZM11.3988 19.2903C7.01432 19.2903 3.50776 15.7837 3.50776 11.3993C3.50776 7.01481 7.01432 3.50825 11.3988 3.50825C15.7833 3.50825 19.2898 7.01481 19.2898 11.3993C19.2898 15.7821 15.7816 19.2903 11.3988 19.2903Z", fill: "" })))))),
        React.createElement("div", { className: "menu-hamburger-icon", style: { float: 'right', top: '3px', position: 'relative' } },
            React.createElement(nav_icon_1.NavIcon, null))));
};
exports.DesktopMenuElements = DesktopMenuElements;
const AnimatedDiv = (0, styled_components_1.default)(react_spring_1.animated.div) ``;
const DesktopMenuWrap = styled_components_1.default.div `
  display: flex;
  align-items: center;

  svg {
    fill: #fff;
    width: 18px;
    height: 23px;
  }
`;
const MenuUl = styled_components_1.default.ul `
  font-size: 18px;
  color: #fff;
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
  float: left;
  display: none;

  li {
    display: inline-block;
    margin: 0;
    padding: 0;
    margin-right: 30px;
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }

  @media (min-width: 1340px) {
    display: block;
  }
`;
const MenuRightElements = styled_components_1.default.div `
  position: relative;
  top: 2px;
  color: #fff;
  font-size: 18px;
  list-style: none;
  margin: 0 15px 0 0;
  padding: 0;
  float: left;

  /*
  li {
    display: inline-block;
    margin: 0;
    margin-right: 30px;
    padding: 0;
    &:last-child {
      margin-right: 0;
    }
  }
  */

  a {
    color: inherit;
    text-decoration: inherit;
  }

  svg {
    margin: 0px 5px 0 0;
    vertical-align: -3px;
  }
`;
//# sourceMappingURL=desktop-menu-elements.js.map